/**
 * Display component with avatar and text bubble
 * 
 */

import React from "react";
import i18n from "./../../Documental/Localization/i18n.js";


class BotChatBubble extends React.Component {
  
  constructor(props) {
    super(props);

		this.showHidetimer = null;

		var resultsDemo = true;
		if( typeof props.resultsDemo == 'undefined' || !props.resultsDemo ){
			resultsDemo = false;
		}

		let botImage = 'https://icon-library.com/images/bot-icon/bot-icon-7.jpg';

		botImage = 'http://give.ee/janar/temporary/dricons/neutral.jpg';

		if( typeof props.botMood != 'undefined' ){
			if( props.botMood == 'questioning' ){
				// https://cdn3.iconfinder.com/data/icons/chat-bot-emoji-blue-filled-color/300/141417841Untitled-3-512.png
				botImage = 'http://give.ee/janar/temporary/dricons/question.jpg';
			}
			if( props.botMood == 'sad' ){
				botImage = 'http://give.ee/janar/temporary/dricons/sad.jpg';
			}
			if( props.botMood == 'suprised' ){
				botImage = 'http://give.ee/janar/temporary/dricons/suprised.jpg';
			}
			if( props.botMood == 'happy' ){
				botImage = 'http://give.ee/janar/temporary/dricons/happy.jpg';
			}
			if( props.botMood == 'wink' ){
				botImage = 'http://give.ee/janar/temporary/dricons/wink.jpg';
			}
			if( props.botMood == 'waiting' ){
				botImage = 'http://give.ee/janar/temporary/dricons/waiting.jpg';
			}
			
		}

		this.state = {
			'animateresults' : 0,
			'animateresultsStart' : resultsDemo,
			'botMoodImage' : botImage
		};
		
    this.handleMatrixItemClick = this.handleMatrixItemClick.bind( this );
    this.handleBotClick = this.handleBotClick.bind( this );
  }


  componentDidMount() {
		window.appEventsEmitter.emit( 'rendered', { "sourceComponent" : "componentBotChatBubble" } );
		if( this.state.animateresultsStart ){
			this.animateResultsAndBotSteps();
		}
		
  }
	
  
  componentDidUpdate(prevProps, prevState) {
		if( this.state.animateresults != 0 ){
			//console.log( 'Card componentDidUpdate?' );
			//this.changeanimationCycle( 0 );
		}
  }
	
  handleBotClick( event ){
    this.changeanimationCycle( 2 );
  }
	
  handleMatrixItemClick( event, obj ){
    this.changeanimationCycle( 0 );
  }
	

  animateResultsAndBotSteps(){
		var that = this;
    
    if( this.showHidetimer != null ){
      clearTimeout( this.showHidetimer );
    }

		let cnt = this.state.animateresults;
		let timerTime = 6000;
		
		if( cnt == 1 ){
			timerTime = 400;
		}
		if( cnt == 2 ){
			timerTime = 4000;
		}
		if( cnt == 3 ){
			timerTime = 400;
		}
		
		this.showHidetimer = setTimeout( function(){
			let cnt = that.state.animateresults;
			cnt++;

      if( cnt > 3 ){
				cnt = 0;
			}
			that.setState({
				animateresults : cnt
			});

			that.animateResultsAndBotSteps();
		}, timerTime );
  }

  changeanimationCycle( toCycle ){
		if( !this.state.animateresultsStart ){
			return;
		}

    if( this.showHidetimer != null ){
      clearTimeout( this.showHidetimer );
    }
		this.setState({
			animateresults : toCycle
		});
		this.animateResultsAndBotSteps();
  }

  
  render() {
		var texts = [];
		
		if( typeof this.props.botText != 'undefined' ){
			texts.push({
				'text' : this.props.botText
			});
		}

		if( typeof this.props.botTexts != 'undefined' ){
			texts = this.props.botTexts;
		}
		
		if( texts.lenght < 1 ){
			texts.push({
				'text' : '&nbsp;'
			});
		}

		//  topicText={topicText} ={topicColorClass

		let topicText = '';
		let topicColorClass = 'mdl-chip chat-bubble-topic';

		if( typeof this.props.topicText != 'undefined' ){
			topicText = this.props.topicText;
		}
		if( typeof this.props.topicExtraClass != 'undefined' ){
			topicColorClass = topicColorClass + ' ' + this.props.topicExtraClass;
		}



		/* 

		// https://icon-library.com/images/bot-icon/bot-icon-20.jpg
		*/

		let botImageClasses   = 'bot-results-fadeable';
		let resultsClasses = 'bot-results-fadeable';
		
		if( !this.state.animateresultsStart ){
			botImageClasses   = '';
			resultsClasses = 'bot-results-fadeable hide';
		}

		if( this.state.animateresults == 0 ){
			botImageClasses = botImageClasses + ' show';
			resultsClasses  = resultsClasses + ' hide';
		} else if( this.state.animateresults == 1 ){
			botImageClasses = botImageClasses + ' hide';
			resultsClasses  = resultsClasses + ' hide';
		} else if( this.state.animateresults == 2 ){
			botImageClasses = botImageClasses + ' hide';
			resultsClasses  = resultsClasses + ' show';
		} else if( this.state.animateresults == 3 ){
			botImageClasses = botImageClasses + ' hide';
			resultsClasses  = resultsClasses + ' hide';
		}


		let language = i18n.language;
    // let matrixContent = window.qHolder.getCurrentQuestionnaireResponseMatrix( language );
		
    return (
			<div className="mdl-grid chat-bot">
				<div className="mdl-cell mdl-cell--2-col mdl-cell--2-col-tablet mdl-cell--1-col-phone chat-bot-avatar">
					{/* assets/img/bot.gif   https://icon-library.com/images/bot-icon/bot-icon-7.jpg 

					<img src={this.state.botMoodImage} className={botImageClasses} onClick={(e) => this.handleBotClick( e )} />
					*/}

				</div>
				<div className="mdl-cell mdl-cell--10-col mdl-cell--6-col-tablet mdl-cell--3-col-phone chat-bot-bubble">
					
        
					{topicText != '' && (
						<span className={topicColorClass}>
								<span className="mdl-chip__text">{topicText}</span>
						</span>
					)}
				  
					<div className="talk-bubble tri-right border left-top">
						<div className="talktext">
							
							{texts.map( function( obj, index){
								let key = index + new Date().getTime();
								let loaderKey = 'loadekey-static';
								let classes = '';
								let text = '&nbsp;';
								
								if( typeof obj.text != 'undefined' ){
									text = obj.text;
								}

								if( typeof obj.isBold != 'undefined' && obj.isBold ){
									classes = ' is-bold';
								}
								if( typeof obj.loader != 'undefined' && obj.loader ){
									return (
										<div className="p" key={loaderKey}>
											<div className="container-loading">
												<div className="mdl-spinner mdl-js-spinner is-active"></div>
											</div>
										</div>
									);
								}
								
								return (
									<p key={key} className={classes}>
										{obj.text}
									</p>
								);
							})}

						</div>
					</div>
				</div>
			</div>
    );
  }

}

export default BotChatBubble;
